import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_custom } from './taskCustom'
import { createTask_goToMachine } from './taskGoToMachine'
import { monsters } from '../monsters/monsters-sidecar'
import { distance } from '../lib/distance-sidecar'

export const register = () => registerJob('sleep', runJob)

function runJob(job: IJob) {
  jobLogger.assertJobType(job, 'sleep')
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runTasks(job)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  const f = (c: IMachine) => c.data.type === 'bed' && c.isOccupied === false

  let mc = machines.findClosestTo(m.i, m.j, f)
  if (!mc) {
    return jobLogger.failJob(job, 'no bed')
  }

  // Go to machine
  if (!distance.isAtIJ(m, mc)) {
    let task = createTask_goToMachine(m.i, m.j, f)
    job.tasks.push(task)
    return
  }

  // Sleep
  let task = createTask_custom(m.i, m.j, (t) => {
    let mc = machines.findAtSpot(m.i, m.j, (c) => c.data.type === 'bed')
    if (!mc) {
      monsters.setIsSleeping(m, false)
      return jobLogger.failTask(job, task, 'lost bed')
    }
    mc.isOccupied = true
    m.statEnergy += 1
    monsters.setIsSleeping(m, true)
    if (m.statEnergy >= 100) {
      mc.isOccupied = false
      monsters.setIsSleeping(m, false)
      jobLogger.succeedTask(job, t)
      return jobLogger.succeedJob(job)
    }
  })
  job.tasks.push(task)
}
// export function advanceJob_moveToStack(job: IJob) {}
